module.exports = __webpack_public_path__ + "static/scale-model-of-filbert-steps-in-berkeley-california-a7b7f4fd206c675ec80777975dd140d4.png";